export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/36169021fe7698c93ad18ec17084cc2d.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 w-full">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <h1 className="font-serif text-5xl md:text-6xl font-bold mb-6 leading-tight">
              <span className="text-white">Fortaleza Music &</span>
              <br />
              <span className="text-[#D2691E]">Mariachi School</span>
            </h1>
            
            <p className="text-xl md:text-2xl font-light mb-8 text-gray-100">
              Porque tu hijo merece más que una actividad extraescolar
            </p>

            <p className="text-lg leading-relaxed mb-10 text-gray-200 max-w-xl">
              Un lugar donde la música construye confianza, disciplina e identidad. Aquí tu hijo no solo aprende a tocar un instrumento, aprende a creer en sí mismo.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToContact}
                className="bg-[#D2691E] text-white px-8 py-4 rounded-full hover:bg-[#B8571A] transition-all shadow-lg flex items-center justify-center gap-3 whitespace-nowrap group"
              >
                <i className="ri-music-2-line text-xl"></i>
                <span className="font-semibold uppercase tracking-wide">Inscribe a tu Hijo Hoy</span>
                <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
              </button>
              
              <button 
                onClick={scrollToContact}
                className="border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white hover:text-[#D2691E] transition-all whitespace-nowrap"
              >
                Solicita Más Información
              </button>
            </div>
          </div>

          <div className="relative hidden md:block">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://readdy.ai/api/search-image?query=Young%20smiling%20children%20ages%208%20to%2012%20wearing%20beautiful%20traditional%20mariachi%20charro%20suits%20with%20silver%20buttons%20and%20embroidery%20holding%20violins%20and%20guitars%20practicing%20together%20in%20a%20bright%20music%20room%20with%20warm%20afternoon%20sunlight%20streaming%20through%20windows%20showing%20concentration%20joy%20and%20teamwork%20high%20quality%20photography%20with%20warm%20color%20grading&width=600&height=800&seq=hero002&orientation=portrait" 
                alt="Estudiantes de mariachi"
                className="w-full h-[600px] object-cover object-top"
              />
              <div className="absolute top-6 right-6 bg-white/95 backdrop-blur-sm px-6 py-4 rounded-2xl shadow-lg">
                <p className="text-sm font-semibold text-[#D2691E]">130+ años de</p>
                <p className="text-sm font-semibold text-gray-800">confianza comunitaria</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
